import { MARBLE_EMAIL_FOOTER } from "@/lib/clients/sendgrid/constants";

// A few email domains for some reason are blocking our emails
// from sending, even though sendgrid says they're delivered.
//
// This is a list of email domains that we will not require email verification for.
export const EMAIL_DOMAINS_NO_VERIFICATION = [
  "schools.nyc.gov",
  "westerville.k12.oh.us", // aggressive school block: Your email has been rejected because it violates organization policy.
  "k12.ny.us",
  "verizon.net",
  "aol.com",
];

/**
 * Email html for reseting a user password
 * @param link: the link to the reset-password page including the jwt token search param used to identify the user email
 */
export const getResetPasswordHTML = (link: string) => {
  return `<h2>Reset Marble Health Password</h2><p><a clicktracking="off" href="${link}">Click here to reset your password</a></p><br/>If you did not request this password reset, it is safe to ignore this email.<br/><br/>${MARBLE_EMAIL_FOOTER}`;
};

export const USER_IMPERSONATION_COOKIE_KEY = "impersonation";
// NextAuth's default session lifetime, pinned so the 2FA step re-issues the
// session cookie with the same lifetime NextAuth gives it.
export const SESSION_MAX_AGE_S = 30 * 24 * 60 * 60;
export const ADMIN_ACCOUNT_DOMAINS = [
  "marblehealth.com",
  // Contracting Team (DRI is Qi)
  "hirehoratio.co",
];
// Marble employees only, deliberately narrower than ADMIN_ACCOUNT_DOMAINS
// (which also covers contractor domains) so we don't auto-provision paid
// Zoom licenses for contractors.
export const MARBLE_EMPLOYEE_EMAIL_DOMAIN = "marblehealth.com";
export const FORCE_ADMIN_ACCOUNT_EMAILS = [
  // Contractors
  "jeffrey.y.q@gmail.com",
  "lee.haejun@gmail.com",
  "sophiamoxi@gmail.com",
  "sophia.moxi@gmail.com",
  "rainajhkim@gmail.com",
  "annetthh@uci.edu",
  "moon_hee_kim@brown.edu",
  "ethancwei@gmail.com",
  "liujingxuan03@gmail.com",
  "lc3706@columbia.edu",
  "zacharybk@gmail.com",
  "hollemonelena@gmail.com",
  // Interns
  "yenlynguyen7@gmail.com",
  // Onshore contractors
  "zoe@solaceandthecity.com",
  "pranavpotrevu@gmail.com",
];

export const INSURANCE_PAYER_SIGNUP_COOKIE_KEY = "insurancePayerSignup";

// Shown when a therapist invite link no longer matches an invited account.
// The invite page shows it as-is instead of logging it as an unknown error.
export const INVALID_INVITE_MESSAGE =
  "This invite link is no longer valid. Please reach out to request a new invite link.";

// Shown when sign-up hits an email that already has an account, whatever its
// type. It never says which type: the page is public, and "a student account"
// would tell anyone who types an email that its owner is in care.
export const EMAIL_IN_USE_MESSAGE =
  "There's already a Marble account with this email. Sign in, or reset your password if you don't remember it.";

export const SYSTEM_USER_EMAIL = "system@marblehealth.com";
